module.exports = __webpack_public_path__ + "img/787.cf531ea0.gif";